export function getPayorName(payor) {
  if (payor.payment_account.account_type === 'PersonPaymentAccount') {
    return payor.payment_account.person_payment_account.payer_person.first_name
  } else {
    return payor.payment_account.insurance_payment_account.insurance_company
      .carrier_name
  }
}
